module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00027.469d77e.png";